import { useMemo } from 'react';
import { DateTimeUtils, useTimezone } from '@mews/framework';
import { AssistantDateFormat, useAssistantDateTimeLocalizationInfo } from './useAssistantShortDateLocalizationInfo';

/**
 * Returns localized date string.
 * This is a modification of a copy of packages/commander/modules/src/modules/marketplace/components/EnterpriseIntegration/components/useLocalizedDate.ts
 * We need to find a good place to share this file.
 */
export const useLocalizedDate = (
    dateTimeUtcString: string | null | undefined,
    format: AssistantDateFormat = AssistantDateFormat.DateMedium
) => {
    const timezone = useTimezone();
    const localizationInfo = useAssistantDateTimeLocalizationInfo(format);

    return useMemo(() => {
        if (!dateTimeUtcString) return '';

        /* Converting to an ISO string is necessary to ensure the correct date format. */
        const dateTimeIsoString = new Date(dateTimeUtcString).toISOString();
        return DateTimeUtils.dateTimeUtcStringToDateString(dateTimeIsoString, localizationInfo, timezone);
    }, [dateTimeUtcString, timezone, localizationInfo]);
};
